import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnSubmit(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onSubmit() {
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
